module.exports = __webpack_public_path__ + "static/media/unavailable-hbcrm.3e2541df.png";